import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import "./Navbar.css";
// import { Link } from "react-router-dom";
import Logo from "./Logo";
import { GoThreeBars } from "react-icons/go";
import { FaTimes} from "react-icons/fa"
   

const Navbar = () => {
 const [click, setClick] = useState(false);
  const closeMobileMenu = () => {
    setClick(!click);
  }
  return (
    <>
      <nav className="container-fluid px-2 mt-2">
       
          <div className="nav-center container-fluid">
          <div className="nav-header">
              <Link to="/" className="nav-brand" onClick={closeMobileMenu}>
                <Logo  className="logo" />
              </Link>
            <div className="nav-toggle " onClick={closeMobileMenu}>
              {click ? <FaTimes className="space" /> : <GoThreeBars className="space" />}
            </div>
          </div>
          
           
                <ul className={click ? "links show-links" : "links"}>
                  <li >
                    <Link to='/' className='nav-links' onClick={closeMobileMenu} >
                      Home
                    </Link>
                    </li>
                  <li >
                    <Link to='/page' className='nav-links' onClick={closeMobileMenu} >
                      Page
                    </Link>
                  </li>
                  <li >
                    <Link to='/services' className='nav-links' onClick={closeMobileMenu} >
                      Service
                    </Link>
                  </li>
                  <li >
                    <Link to='/blog' className='nav-links' onClick={closeMobileMenu} >
                      BLOG
                    </Link>
                  </li>
                  <li >
                    <Link to='/contact' className='nav-links' onClick={closeMobileMenu} >
                      Contact
                    </Link>
                  </li>
                </ul>
             
          </div>
       
      </nav>
    </>
  );
};

export default Navbar;
